import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const metricsRoutes = [
  {
    path: '/metrics/incidents',
    name: Routes.IncidentMetrics,
    component: () => import('@/pages/contexts/portal/metrics/Incidents.vue'),
    meta: {
      pageTitle: 'Incident Metrics',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
    },
  },
  {
    path: '/metrics/assessments-and-training',
    name: Routes.AssessmentsAndTrainingMetrics,
    component: () => import('@/pages/contexts/portal/metrics/AssessmentsAndTraining.vue'),
    meta: {
      pageTitle: 'Assessments & Training Metrics',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
    },
  },
  {
    path: '/metrics/on-site-sales',
    name: Routes.OnSiteSalesMetrics,
    component: () => import('@/pages/contexts/portal/metrics/OnSiteSales.vue'),
    meta: {
      pageTitle: 'On Site Sales',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_SALES_METRICS,
    },
  },
  {
    path: '/metrics/daily-client-totals',
    name: Routes.DailyClientTotals,
    component: () => import('@/pages/contexts/portal/metrics/DailyClientTotals.vue'),
    meta: {
      pageTitle: 'Daily Client Totals',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_METRICS,
    },
  },
  {
    path: '/metrics/annual-client-totals',
    name: Routes.AnnualClientTotals,
    component: () => import('@/pages/contexts/portal/metrics/AnnualClientTotals.vue'),
    meta: {
      pageTitle: 'Annual Client Totals',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_METRICS,
    },
  },
  {
    path: '/metrics/seat-utilisation-rates',
    name: Routes.SeatUtilisationRates,
    component: () => import('@/pages/contexts/portal/metrics/SeatUtilisationRates.vue'),
    meta: {
      pageTitle: 'Seat Utilisation Rates',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_METRICS,
    },
  },
]
